<template>
  <div class="event-screen">
    <div class="back-button">
      <el-button @click="navigateBack">
        返回主屏幕
      </el-button>
    </div>
    
    <div class="screen-title">
      事件管理
    </div>
    
    <el-row
      :gutter="20"
      class="data-cards"
    >
      <el-col :span="6">
        <el-card class="data-card">
          <h3>累计工单</h3>
          <div class="big-number">
            568
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="data-card">
          <h3>未办结工单</h3>
          <div class="big-number">
            128
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="data-card">
          <h3>督办工单</h3>
          <div class="big-number">
            35
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="data-card">
          <h3>办结率</h3>
          <div class="big-number">
            77.5%
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row
      :gutter="20"
      class="charts-row"
    >
      <el-col :span="12">
        <el-card class="chart-card">
          <h3>事件类型分布</h3>
          <div class="chart-container">
            <div
              ref="eventTypeDistributionChart"
              style="width: 100%; height: 300px;"
            />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="chart-card">
          <h3>处理状态分布</h3>
          <div class="chart-container">
            <div
              ref="processingStatusChart"
              style="width: 100%; height: 300px;"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row
      :gutter="20"
      class="charts-row"
    >
      <el-col :span="24">
        <el-card class="chart-card">
          <h3>近7天事件趋势</h3>
          <div class="chart-container">
            <div
              ref="eventTrendChart"
              style="width: 100%; height: 300px;"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

// ... existing code ...
<script>
import { ref, onMounted, nextTick } from 'vue' // 导入 nextTick
import { useRouter } from 'vue-router'
import * as echarts from 'echarts'

export default {
  name: 'EventScreen',
  setup() {
    const router = useRouter()
    const eventTypeDistributionChart = ref(null)
    const processingStatusChart = ref(null)
    const eventTrendChart = ref(null)
    
    const navigateBack = () => {
      router.push({ name: 'MainDashboard' })
    }
    
    // 添加强制初始化图表函数
    const forceInitChart = (chartRef, option) => {
      if (!chartRef.value) {
        console.error('图表容器不存在')
        return null
      }
      
      // 检查容器尺寸
      const container = chartRef.value
      const rect = container.getBoundingClientRect()
      
      // 如果尺寸为0，尝试强制设置尺寸
      if (rect.width === 0 || rect.height === 0) {
        console.warn('图表容器尺寸为0，尝试强制设置尺寸')
        container.style.width = '100%'
        container.style.height = '300px'
        // 重新获取尺寸
        const newRect = container.getBoundingClientRect()
        if (newRect.width === 0 || newRect.height === 0) {
          console.error('强制设置尺寸后仍无效，创建临时div')
          // 创建临时div作为备选容器
          const tempDiv = document.createElement('div')
          tempDiv.style.width = '100%'
          tempDiv.style.height = '300px'
          document.body.appendChild(tempDiv)
          const chartInstance = echarts.init(tempDiv)
          chartInstance.setOption(option)
          // 延迟移除临时div
          setTimeout(() => {
            document.body.removeChild(tempDiv)
          }, 1000)
          return chartInstance
        }
      }
      
      // 正常初始化图表
      const chartInstance = echarts.init(container)
      chartInstance.setOption(option)
      
      // 添加窗口大小变化监听
      window.addEventListener('resize', () => {
        chartInstance.resize()
      })
      
      return chartInstance
    }
    
    // 生成近7天日期数组的函数
    const generateLast7Days = () => {
      const dates = []
      const today = new Date()
      
      // 从今天开始，依次前推6天，总共7天
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today)
        date.setDate(today.getDate() - i)
        const month = date.getMonth() + 1
        const day = date.getDate()
        dates.push(`${month}/${day}`)
      }
      
      return dates
    }
    
    onMounted(() => {
      // 使用 requestAnimationFrame 和 nextTick 确保DOM已准备好
      requestAnimationFrame(() => {
        nextTick(() => {
          // 初始化事件类型分布图表
          forceInitChart(eventTypeDistributionChart, {
            tooltip: { trigger: 'item' },
            radar: {
              indicator: [
                { name: '安全事件', max: 200 },
                { name: '环境卫生', max: 200 },
                { name: '公共设施', max: 200 },
                { name: '邻里纠纷', max: 200 },
                { name: '其他', max: 200 }
              ],
              radius: '70%',
              splitNumber: 5,
              axisName: {
                color: '#fff',
                fontSize: 12
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.2)'
                }
              },
              splitArea: {
                show: true,
                areaStyle: {
                  color: ['rgba(24, 144, 255, 0.1)', 'rgba(24, 144, 255, 0.05)']
                }
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)'
                }
              }
            },
            series: [{
              name: '事件类型',
              type: 'radar',
              data: [
                {
                  value: [120, 80, 150, 60, 90],
                  name: '事件数量',
                  itemStyle: {
                    color: '#1890ff'
                  },
                  lineStyle: {
                    color: '#1890ff',
                    width: 2
                  },
                  areaStyle: {
                    color: 'rgba(24, 144, 255, 0.3)'
                  }
                }
              ]
            }]
          })
          
          // 初始化处理状态分布图表
          forceInitChart(processingStatusChart, {
            tooltip: { trigger: 'item' },
            color: ['#1E3A8A', '#2563EB', '#60A5FA'],
            series: [{
              name: '处理状态',
              type: 'pie',
              radius: ['40%', '70%'],
              data: [
                { value: 440, name: '已办结' },
                { value: 93, name: '处理中' },
                { value: 35, name: '督办中' }
              ]
            }]
          })
          
          // 初始化近7天事件趋势图表
          const last7Days = generateLast7Days()
          forceInitChart(eventTrendChart, {
            tooltip: { trigger: 'axis' },
            legend: {
              data: ['新增事件', '已处理'],
              top: '5%',
              left: 'center',
              textStyle: {
                color: '#fff',
                fontSize: 12
              },
              itemWidth: 12,
              itemHeight: 8,
              itemGap: 15
            },
            xAxis: { type: 'category', data: last7Days },
            yAxis: { type: 'value' },
            series: [
              { name: '新增事件', data: [15, 20, 18, 25, 30, 22, 28], type: 'line' },
              { name: '已处理', data: [10, 15, 20, 18, 22, 25, 20], type: 'line' }
            ]
          })
        })
      })
    })
    
    return {
      eventTypeDistributionChart,
      processingStatusChart,
      eventTrendChart,
      navigateBack
    }
  }
}
</script>
// ... existing code ...

<style scoped>
.event-screen {
  background-color: #000000;
  color: white;
  padding: 20px;
  min-height: 100vh;
  box-sizing: border-box;
}

.screen-title {
  font-size: 32px;
  font-weight: bold;
  color: white;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 20px;
}

.back-button {
  margin-bottom: 20px;
  text-align: left;
}

.back-button .el-button {
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  border: none;
  color: white;
}

.data-cards {
  margin-bottom: 20px;
}

.data-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  color: white;
  text-align: center;
  padding: 15px;
  box-sizing: border-box;
}

.big-number {
  font-size: 36px;
  font-weight: bold;
  margin: 20px 0;
}

.charts-row {
  margin-bottom: 20px;
}

.chart-card {
  border: none;
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  color: white;
  padding: 0;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(24, 144, 255, 0.4), inset 0 0 25px rgba(24, 144, 255, 0.15);
  margin-bottom: 20px;
}

.chart-container {
  width: 100% !important;
  height: 300px !important; /* 添加 !important 确保优先级 */
  min-height: 300px !important; /* 设置最小高度 */
  box-sizing: border-box !important; /* 确保 padding 和 border 不影响尺寸 */
  border: none;
  background-color: transparent;
}

/* 添加额外的样式覆盖，确保 Element UI 卡片不影响图表容器 */
:deep(.chart-card .el-card__body) {
  height: 100%;
  padding: 15px !important;
  box-sizing: border-box;
}
</style>